<template>
  <v-dialog v-model="internalValue" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar height="40" color="blue" dark flat>
        <v-icon left class="mt-1">mdi-file-document-multiple</v-icon>
        <span class="mt-1 headline">Detalle de guía - {{ awb }}</span>
        <v-spacer></v-spacer>
        <v-btn v-if="cargosFacturacion" small text dark class="mr-1" :disabled="!cabecera.CABECERA_ID" @click="verCargos">
          <v-icon left>mdi-cash-multiple</v-icon> Cargos
        </v-btn>
        <v-btn small text dark class="mr-1" :loading="descargando == 'coordinacion'" :disabled="!cabecera.CABECERA_ID" @click="descargar('coordinacion')">
          <v-icon left>mdi-file-excel</v-icon> Coordinación
        </v-btn>
        <v-btn small text dark class="mr-1" :loading="descargando == 'acas'" :disabled="!cabecera.CABECERA_ID" @click="descargar('acas')">
          <v-icon left>mdi-file-excel</v-icon> ACAS
        </v-btn>
        <v-btn small text dark class="mr-2" :loading="descargando == 'pesos'" :disabled="!cabecera.CABECERA_ID" @click="descargar('pesos')">
          <v-icon left>mdi-file-excel</v-icon> Detalle de pesos
        </v-btn>
        <v-btn @click="cerrar" icon dark><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text class="pa-4">
        <v-card outlined class="mb-3 px-3 pt-3 pb-1">
          <v-row dense>
            <v-col cols="4">
              <v-text-field label="Consignatario" :value="cabecera.CLIENTE_NOMBRE" readonly dense hide-details></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field label="Fecha" :value="cabecera.FECHA" readonly dense hide-details></v-text-field>
            </v-col>
            <v-col cols="2">
              <div class="caption grey--text">Estado</div>
              <v-chip v-if="cabecera.ESTADO" small :color="colorEstado" text-color="white">{{ cabecera.ESTADO }}</v-chip>
            </v-col>
            <v-col cols="2">
              <v-text-field label="Total cajas" :value="(cabecera.TOTAL_CAJAS ?? 0).toFixed(2)" readonly dense hide-details></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field label="Total piezas" :value="cabecera.TOTAL_PIEZAS" readonly dense hide-details></v-text-field>
            </v-col>
          </v-row>
          <v-row dense class="mt-2">
            <v-col cols="6">
              <v-textarea
                v-model="estadoVueloEdit"
                label="Estado del vuelo"
                :readonly="!editandoVuelo"
                rows="2"
                auto-grow
                dense
                hide-details
                counter="160"
              >
                <template v-slot:append-outer>
                  <template v-if="editarEstadoVuelo">
                    <v-btn v-if="!editandoVuelo" icon small @click="editandoVuelo = true"><v-icon small>mdi-pencil</v-icon></v-btn>
                    <template v-else>
                      <v-btn icon small color="success" :loading="guardandoVuelo" @click="guardarEstadoVuelo"><v-icon small>mdi-content-save</v-icon></v-btn>
                      <v-btn icon small @click="cancelarEstadoVuelo"><v-icon small>mdi-close</v-icon></v-btn>
                    </template>
                  </template>
                </template>
              </v-textarea>
            </v-col>
            <v-col cols="3" v-if="cabecera.ES_MARITIMA">
              <v-text-field
                v-model="numBlEdit"
                label="Número de BL"
                :readonly="!editandoBl"
                maxlength="35"
                dense
                hide-details
              >
                <template v-slot:append-outer>
                  <template v-if="seguimientoMaritimo">
                    <v-btn v-if="!editandoBl" icon small @click="editandoBl = true"><v-icon small>mdi-pencil</v-icon></v-btn>
                    <template v-else>
                      <v-btn icon small color="success" :loading="guardandoBl" @click="guardarBl"><v-icon small>mdi-content-save</v-icon></v-btn>
                      <v-btn icon small @click="cancelarBl"><v-icon small>mdi-close</v-icon></v-btn>
                    </template>
                  </template>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-card>

        <v-row class="mb-3">
          <v-col cols="4">
            <v-autocomplete
              v-model="filtroSubCliente"
              :items="subClientes"
              item-text="SCLI_NOMBRE"
              item-value="ENTE_ID"
              label="Filtrar por Sub Cliente"
              clearable
              @change="cargarGuiasHijas()"
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="3" v-if="consolidado">
            <v-switch v-model="agruparSubCliente" label="Agrupar por subcliente" dense hide-details class="mt-1"></v-switch>
          </v-col>
          <v-col class="text-right">
            <v-chip color="primary" text-color="white" small>
              {{ lista.length }} registros
            </v-chip>
          </v-col>
        </v-row>

        <v-data-table
          :headers="getHeaders"
          :items="lista"
          :items-per-page="-1"
          :loading="loading"
          :group-by="consolidado && agruparSubCliente ? 'SCLI_NOMBRE' : []"
          class="elevation-1 guia-hijas-table"
          style="font-size:11px; white-space: nowrap; flex-grow: 1;  flex-shrink: 0;  display: flex; flex-direction: column;  position: relative;  "
          hide-default-footer
          dense
          fixed-header
          height="calc(100vh - 330px)"
        >
          <template v-slot:group.header="{ group, headers, toggle, isOpen }">
            <td :colspan="headers.length" class="grupo-subcliente">
              <v-btn icon x-small @click="toggle"><v-icon>{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon></v-btn>
              <span class="font-weight-bold">{{ group || 'SIN SUBCLIENTE' }}</span>
              <span class="ml-4">Cajas: {{ subtotal(group, 'CAJAS_CONF').toFixed(2) }}</span>
              <span class="ml-4">Piezas: {{ subtotal(group, 'PIEZAS_CONF') }}</span>
            </td>
          </template>
          <template v-slot:item.TEMP_REC="{ item }">
            {{ item.TEMP_REC ? item.TEMP_REC + ' °C' : '' }}
          </template>
          <template v-slot:item.GROSS_WT_RDO="{ item }">
            {{ (item.GROSS_WT_RDO ?? 0).toFixed(2) }}
          </template>
          <template v-slot:item.CHARGABLE_WT_RDO="{ item }">
            {{ (item.CHARGABLE_WT_RDO ?? 0).toFixed(2) }}
          </template>
          <template v-slot:body.append>
            <tr class="totales-row" v-if="consolidado==true">
              <td colspan="4" class="font-weight-bold text-left">TOTAL</td>
              <td class="font-weight-bold text-right">{{ totales.CAJAS_CONF ?? 0 }}</td>
              <td class="font-weight-bold text-center">{{ totales.PIEZAS_CONF ?? 0 }}</td>
              <td class="font-weight-bold text-center">{{ totales.FULL ?? 0 }}</td>
              <td class="font-weight-bold text-center">{{ totales.HALF ?? 0 }}</td>
              <td class="font-weight-bold text-center">{{ totales.QUARTER ?? 0 }}</td>
              <td class="font-weight-bold text-center">{{ totales.THIRD ?? 0 }}</td>
              <td class="font-weight-bold text-center">{{ totales.SIXTH ?? 0 }}</td>
              <td class="font-weight-bold text-center">{{ totales.EIGHTH ?? 0 }}</td>
              <td class="font-weight-bold text-center">{{ totales.SIXTEENTH ?? 0 }}</td>
              <td class="font-weight-bold text-right">{{ (totales.GROSS_WT_RDO ?? 0).toFixed(2) }}</td>
              <td></td>
              <td class="font-weight-bold text-right">{{ (totales.CHARGABLE_WT_RDO ?? 0).toFixed(2) }}</td>
            </tr>

            <tr class="totales-row" v-if="consolidado==false">
              <td colspan="4" class="font-weight-bold text-left">TOTAL</td>
              <td class="font-weight-bold text-right">{{ totales.CAJAS_CONF ?? 0 }}</td>
              <td class="font-weight-bold text-center">{{ totales.PIEZAS_CONF ?? 0 }}</td>
              <td class="font-weight-bold text-center">{{ totales.FULL ?? 0 }}</td>
              <td class="font-weight-bold text-right">{{ (totales.GROSS_WT_RDO ?? 0).toFixed(2) }}</td>
              <td></td>
              <td class="font-weight-bold text-right">{{ (totales.CHARGABLE_WT_RDO ?? 0).toFixed(2) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";

export default {
  name: "DetalleGuiaHijas",
  props: {
    value: { type: Boolean, required: true },
    awb: { type: String, required: true },
  },
  data: () => ({
    internalValue: false,
    lista: [],
    subClientes: [],
    filtroSubCliente: null,
    loading: false,
    totales: {},
    subtotales: {},
    cabecera: {},
    agruparSubCliente: false,
    editandoVuelo: false,
    estadoVueloEdit: "",
    guardandoVuelo: false,
    editandoBl: false,
    numBlEdit: "",
    guardandoBl: false,
    descargando: "",
    headers: [
      { text: "HAWB", value: "NUM_GUIA_FINCA" },
      { text: "Finca", value: "FINCA_NOMBRE" },
      { text: "Sub Cliente", value: "SCLI_NOMBRE" },
      { text: "Cliente Final", value: "CF_NOMBRE" },
      { text: "Cajas Conf.", value: "CAJAS_CONF", align: "right" },
      { text: "Piezas Conf.", value: "PIEZAS_CONF", align: "center" },
      { text: "F", value: "FULL" , align: "center" },
      { text: "H", value: "HALF", align: "center" },
      { text: "QT", value: "QUARTER", align: "center" },
      { text: "TH", value: "THIRD", align: "center" },
      { text: "SX", value: "SIXTH", align: "center" },
      { text: "EH", value: "EIGHTH", align: "center" },
      { text: "ST", value: "SIXTEENTH", align: "center" },
      { text: "Peso", value: "GROSS_WT_RDO", align: "right" },
      { text: "Temp.", value: "TEMP_REC", align: "center" },
      { text: "Chargable W.", value: "CHARGABLE_WT_RDO", align: "end" },
    ],
    headers2: [
      { text: "HAWB", value: "NUM_GUIA_FINCA" },
      { text: "Finca", value: "FINCA_NOMBRE" },
      { text: "Comercializadora", value: "COMER_NOMBRE" },
      { text: "Consignatario", value: "SCLI_NOMBRE" },
      { text: "Cajas Conf.", value: "CAJAS_CONF", align: "right" },
      { text: "Piezas Conf.", value: "PIEZAS_CONF", align: "center" },
      { text: "F", value: "FULL" , align: "center" },
      { text: "Peso", value: "GROSS_WT_RDO", align: "right" },
      { text: "Temp.", value: "TEMP_REC", align: "center" },
      { text: "Chargable W.", value: "CHARGABLE_WT_RDO", align: "end" },
    ],
    getHeaders: [],
    consolidado: false
  }),
  computed: {
    ...mapGetters("access", ["seguimientoMaritimo", "editarEstadoVuelo", "cargosFacturacion"]),

    colorEstado() {
      if (this.cabecera.ESTADO == "ABIERTA") return "green";
      if (this.cabecera.ESTADO == "RESERVADA") return "orange";
      return "grey";
    },
  },
  watch: {
    value(val) {
      this.internalValue = val;
      if (val) {
        this.cargarGuiasHijas();
      }
    },
    internalValue(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    ...mapMutations("master", ["setUrl"]),
    ...mapActions("master", ["requestApi", "alertNotification"]),

    cargarGuiasHijas() {
      this.loading = true;
      this.setUrl("api/guias-hijas-por-guia");
      this.requestApi({
        method: "GET",
        data: {
          awb: this.awb,
          sub_cliente_id: this.filtroSubCliente || "",
        },
      })
        .then((res) => {
          this.consolidado = res.data.consolidado || false;
          if(this.consolidado == true)
            this.getHeaders = this.headers;
          else
            this.getHeaders = this.headers2;

          this.lista = res.data.lista || [];
          this.totales = res.data.totales || {};
          this.subtotales = res.data.subtotales || {};
          this.cabecera = res.data.cabecera || {};
          if (!this.editandoVuelo) this.estadoVueloEdit = this.cabecera.ESTADO_VUELO || "";
          if (!this.editandoBl) this.numBlEdit = this.cabecera.NUM_BL || "";
          if (!this.filtroSubCliente) {
            this.subClientes = res.data.sub_clientes || [];
          }
        })
        .catch(() => {
          this.lista = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    subtotal(grupo, campo) {
      const s = this.subtotales[grupo || ""] || {};
      return Number(s[campo] ?? 0);
    },

    guardarEstadoVuelo() {
      this.guardandoVuelo = true;
      this.setUrl("api/guardar-estado-vuelo");
      this.requestApi({
        method: "POST",
        data: {
          cabecera_id: this.cabecera.CABECERA_ID,
          estado_vuelo: this.estadoVueloEdit,
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.cabecera.ESTADO_VUELO = this.estadoVueloEdit;
          this.editandoVuelo = false;
          this.$emit("actualizado");
        })
        .catch(() => {})
        .finally(() => {
          this.guardandoVuelo = false;
        });
    },

    cancelarEstadoVuelo() {
      this.estadoVueloEdit = this.cabecera.ESTADO_VUELO || "";
      this.editandoVuelo = false;
    },

    guardarBl() {
      this.guardandoBl = true;
      this.setUrl("api/asignar-bl-guias");
      this.requestApi({
        method: "POST",
        data: {
          cabecera_ids: [this.cabecera.CABECERA_ID],
          num_bl: this.numBlEdit,
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.numBlEdit = (this.numBlEdit || "").trim().toUpperCase();
          this.cabecera.NUM_BL = this.numBlEdit;
          this.editandoBl = false;
          this.$emit("actualizado");
        })
        .catch(() => {})
        .finally(() => {
          this.guardandoBl = false;
        });
    },

    cancelarBl() {
      this.numBlEdit = this.cabecera.NUM_BL || "";
      this.editandoBl = false;
    },

    verCargos() {
      this.$router.push({ path: "/cargos-guia", query: { cabecera_id: this.cabecera.CABECERA_ID } });
    },

    //los archivos siempre son de la guia completa, sin el filtro de subcliente
    descargar(tipo) {
      this.descargando = tipo;
      const urls = {
        coordinacion: "api/archivo-coordinacion-guia",
        acas: "api/archivo-acas-guia",
        pesos: "api/archivo-detalle-pesos-guia",
      };
      this.setUrl(urls[tipo]);
      this.requestApi({
        method: "GET",
        data: { awb: this.awb },
      })
        .then((res) => {
          let a = document.createElement("a");
          a.href =
            "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
            res.data.datos;
          a.download = res.data.archivo;
          a.click();
        })
        .catch(() => {})
        .finally(() => {
          this.descargando = "";
        });
    },

    cerrar() {
      this.internalValue = false;
      this.filtroSubCliente = null;
      this.lista = [];
      this.totales = {};
      this.subtotales = {};
      this.cabecera = {};
      this.agruparSubCliente = false;
      this.editandoVuelo = false;
      this.editandoBl = false;
    },
  },
};
</script>

<style>
.guia-hijas-table.v-data-table .v-data-table__td {
  font-size: 11px !important;
  white-space: nowrap;
}
.guia-hijas-table.v-data-table .v-data-table__th {
  font-size: 11px !important;
  white-space: nowrap;
}
.guia-hijas-table .v-data-table__wrapper {
  overflow-x: auto;
}
.guia-hijas-table table {
  min-width: 100%;
}
.guia-hijas-table .grupo-subcliente {
  background-color: #f5f5f5 !important;
  font-size: 11px !important;
}
.totales-row td {
  position: sticky;
  bottom: 0;
  z-index: 2;
  background-color: #e3f2fd !important;
  border-top: 2px solid #90caf9 !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  font-size: 10pt !important;
  font-weight: bold !important;
}
</style>
